import {createContext} from 'react'
import {AlertColor} from '@mui/material'

interface NotificationContextType {
  lastMessage: any
  subscribe: (v: (data: any) => void) => void
  unsubscribe: () => void
  showNotification: (message: string, severity?: AlertColor) => void
}

const notificationContext = createContext<NotificationContextType>({
  lastMessage: {},
  showNotification: () => {},
  unsubscribe: () => {},
  subscribe: () => {},
})

export default notificationContext
